// Accessibility enhancements for BrainyTots
document.addEventListener('DOMContentLoaded', function() {
  // Keyboard navigation for FAQ accordions
  const faqItems = document.querySelectorAll('.bt-faq-item');

  faqItems.forEach(item => {
    const summary = item.querySelector('.bt-faq-question');
    const content = item.querySelector('.bt-faq-answer');

    summary.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        item.toggleAttribute('open');
        updateAriaExpanded(this);
        announceToScreenReader(
          item.hasAttribute('open') ? 'Question expanded' : 'Question collapsed',
          'assertive'
        );
      }
    });

    // Update ARIA attributes
    updateAriaExpanded(summary);
  });

  function updateAriaExpanded(element) {
    const isOpen = element.closest('.bt-faq-item').hasAttribute('open');
    element.setAttribute('aria-expanded', isOpen.toString());
  }

  // SEO intro accordion keyboard navigation
  const seoIntroSummary = document.querySelector('.bt-seo-intro-summary');
  if (seoIntroSummary) {
    seoIntroSummary.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const details = this.closest('.bt-seo-intro-details');
        details.toggleAttribute('open');
        updateAriaExpanded(this);
      }
    });
    updateAriaExpanded(seoIntroSummary);
  }

  // Sticky ATC focus management
  const stickyAtc = document.querySelector('.bt-sticky-atc-bar');
  if (stickyAtc) {
    // Skip link to sticky ATC
    const skipLink = document.createElement('a');
    skipLink.href = '#bt-sticky-atc-content';
    skipLink.className = 'visually-hidden focusable';
    skipLink.textContent = 'Skip to add to cart options';
    skipLink.style.cssText = `
      position: absolute;
      left: -9999px;
      z-index: 9999;
    `;
    skipLink.addEventListener('focus', function() {
      this.style.left = '10px';
      this.style.top = '10px';
    });
    skipLink.addEventListener('blur', function() {
      this.style.left = '-9999px';
    });

    document.body.insertBefore(skipLink, document.body.firstChild);

    // Focus trap in sticky ATC when opened
    const atcButton = stickyAtc.querySelector('.bt-sticky-atc-button .button');
    if (atcButton) {
      atcButton.setAttribute('id', 'bt-sticky-atc-content');

      atcButton.addEventListener('focus', function() {
        stickyAtc.classList.add('focused');
      });

      atcButton.addEventListener('blur', function() {
        stickyAtc.classList.remove('focused');
      });
    }
  }

  // Trust bar screen reader announcements
  const trustBadges = document.querySelectorAll('.bt-trust-badge');
  trustBadges.forEach(badge => {
    badge.setAttribute('role', 'text');
    badge.setAttribute('aria-label', badge.textContent.trim());
  });

  // Learning outcomes grid keyboard navigation
  const outcomesGrid = document.querySelector('.bt-learning-outcomes');
  if (outcomesGrid) {
    const badges = outcomesGrid.querySelectorAll('.bt-outcome-badge');
    badges.forEach((badge, index) => {
      badge.setAttribute('tabindex', '0');
      badge.setAttribute('role', 'button');
      badge.setAttribute('aria-label', `Learning outcome: ${badge.textContent.trim()}`);

      badge.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          // Could trigger a tooltip or modal with more info
          announceToScreenReader(`Selected learning outcome: ${this.textContent.trim()}`);
          console.log(`Selected learning outcome: ${this.textContent.trim()}`);
        }
      });

      badge.addEventListener('click', function() {
        announceToScreenReader(`Selected learning outcome: ${this.textContent.trim()}`);
      });
    });
  }

  // Trust bar badges keyboard navigation
  trustBadges.forEach(badge => {
    badge.setAttribute('tabindex', '0');
    badge.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        announceToScreenReader(`Trust badge: ${this.textContent.trim()}`);
      }
    });
  });

  // Product image alt text validation
  const productImages = document.querySelectorAll('.product__media img');
  productImages.forEach(img => {
    if (!img.getAttribute('alt') || img.getAttribute('alt') === '') {
      img.setAttribute('alt', `Product image for ${document.querySelector('.product__title h1')?.textContent || 'product'}`);
    }
  });

  // Collection image alt text
  const collectionImages = document.querySelectorAll('.collection-hero__image img');
  collectionImages.forEach(img => {
    if (!img.getAttribute('alt') || img.getAttribute('alt') === '') {
      img.setAttribute('alt', `Collection image for ${document.querySelector('.collection-hero__title')?.textContent || 'collection'}`);
    }
  });

  // Article image alt text
  const articleImages = document.querySelectorAll('.article-template__content img');
  articleImages.forEach(img => {
    if (!img.getAttribute('alt') || img.getAttribute('alt') === '') {
      img.setAttribute('alt', `Article image for ${document.querySelector('.article-template__title')?.textContent || 'article'}`);
    }
  });
});

// Screen reader announcements for dynamic content
function announceToScreenReader(message, priority = 'polite') {
  const announcement = document.createElement('div');
  announcement.setAttribute('aria-live', priority);
  announcement.setAttribute('aria-atomic', 'true');
  announcement.className = 'sr-only';
  announcement.style.cssText = `
    position: absolute;
    left: -10000px;
    width: 1px;
    height: 1px;
    overflow: hidden;
  `;
  announcement.textContent = message;

  document.body.appendChild(announcement);

  setTimeout(() => {
    document.body.removeChild(announcement);
  }, 1000);
}

// Announce sticky ATC appearance/disappearance
const stickyObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      announceToScreenReader('Add to cart options available at bottom of page');
    }
  });
}, {
  threshold: 0,
  rootMargin: '-100px 0px -100px 0px'
});

const productInfo = document.querySelector('.product__info-container');
if (productInfo) {
  stickyObserver.observe(productInfo);
}

// Announce trust bar on PDP load
if (document.querySelector('.bt-trust-bar')) {
  setTimeout(() => {
    announceToScreenReader('Product trust badges: BIS Certified, Pediatrician Endorsed, Award Winning, Free Returns and Free Shipping');
  }, 1000);
}

// Keyboard navigation for micro CTA buttons
document.addEventListener('keydown', function(e) {
  if (e.target.matches('.bt-micro-cta-button')) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.target.click();
      announceToScreenReader('Opening quiz or guide');
    }
  }
});

// Focus management for modal popups (if any)
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    // Close any open accordions or modals
    const openFaqs = document.querySelectorAll('.bt-faq-item[open]');
    const openSeoIntro = document.querySelector('.bt-seo-intro-details[open]');

    openFaqs.forEach(faq => faq.removeAttribute('open'));
    if (openSeoIntro) {
      openSeoIntro.removeAttribute('open');
    }
  }
});

// High contrast mode support
function checkHighContrastMode() {
  const testElement = document.createElement('div');
  testElement.style.cssText = 'position: absolute; left: -9999px; background: rgb(31, 41, 55);';
  document.body.appendChild(testElement);

  const computedStyle = window.getComputedStyle(testElement);
  const isHighContrast = computedStyle.backgroundColor === 'rgb(31, 41, 55)';

  document.body.removeChild(testElement);

  if (isHighContrast) {
    document.documentElement.classList.add('high-contrast-mode');
  }
}

checkHighContrastMode();

// Reduced motion support
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (prefersReducedMotion) {
  document.documentElement.classList.add('reduced-motion');
}
